import React, { FC } from 'react';
import { ContentListImageGrid } from 'components/energy5/structures';
import { ledHeaderImage } from 'assets/images/led-landing';
import useI18n from "evcharging/hooks/useI18n";

const HeaderLedSection: FC = () => {
  const { t } = useI18n();

  return (
    <ContentListImageGrid
      imageSrc={ledHeaderImage}
      title={{
        beforeHighlightText: t('landing.title-before'),
        highlightText: t('landing.title-after'),
        text: t('landing.title'),
      }}
      description={t('landing.description')}
      link={{ href: '/lighting-retrofit/project-intro', text: t('landing.get-started') }}
      contentLg={6}
    />
  );
};

export default HeaderLedSection;
